import { Artist } from './types';

export const inOutscapeData: Artist[] = [
  {
    id: "kotaro-yokomizo",
    name: "Kotaro Yokomizo",
    nameThai: "",
    background: {
      en: "Photography begins on the path I walk casually. After moving from Paris to Chiang Mai, I began working on a photo book. Using such photographs, this exhibition features selected works from the photo book SOI 1, compiled in Chiang Mai. I hope you will enjoy viewing the works as a new map.  Born in Tokyo in 1993; moved to France in 2011 to work independently; moved to Chiang Mai in 2021 and continues photographing the streets of Chiang Mai.",
      th: "การถ่ายภาพเริ่มต้นบนเส้นทางที่ฉันเดินอย่างไม่เร่งรีบ หลังจากย้ายจากปารีสมาเชียงใหม่ ฉันก็เริ่มทำหนังสือภาพ นิทรรศการนี้คัดสรรผลงานจากหนังสือภาพ SOI 1 ที่รวบรวมในเชียงใหม่ หวังว่าคุณจะเพลิดเพลินกับการชมผลงานเสมือนแผนที่ใหม่  เกิดที่กรุงโตเกียว พ.ศ. 2536 ย้ายไปฝรั่งเศส พ.ศ. 2554 และย้ายมาเชียงใหม่ พ.ศ. 2564 พร้อมเดินหน้าถ่ายภาพท้องถนนเชียงใหม่อย่างต่อเนื่อง"
    },
    concept: {
      title: "In : Outscape",
      description: "In / Outscape brings together the subtly nuanced woodcut prints of interior spaces by Praween Piangchoompu and the sharply composed black-and-white street photography of Chiang Mai by Kotaro Yokomizo. At first glance, their practices seem worlds apart—one introspective and quiet, the other immediate and raw—but together, they form a liminal continuum between inside and out, seen and unseen, conscious and subconscious. Their works unfold like a lucid dream.",
      descriptionThai: "In / Outscape ผสมผสานภาพพิมพ์แกะไม้อันละเอียดอ่อนของพื้นที่ภายในโดยประวีณ เปียงชมพู และภาพถ่ายสตรีทขาวดำของเชียงใหม่ที่จัดวางอย่างเฉียบคมโดย Kotaro Yokomizo เมื่อแรกเห็น แนวทางของทั้งคู่ต่างกันราวคนละโลก—ด้านหนึ่งเก็บงำ เงียบสงบ อีกด้านเร่งด่วนและดิบ แต่เมื่ออยู่ร่วมกัน พวกเขากลับก่อเกิดเป็นเส้นต่อเนื่องระหว่างภายในและภายนอก สิ่งที่มองเห็นและมองไม่เห็น จิตสำนึกและจิตใต้สำนึก ผลงานคลี่ตัวราวกับความฝันอันแจ่มชัด"
    },
    artworks: [
      {
        id: "uramichi-book",
        title: "Uramichi",
        titleThai: "",
        image: "/images/InOutscape/Kotaro Yokomizo/uramichi book.jpeg",
        medium: "Handmade Paper, Silkscreen (edition of 100)",
        mediumThai: "",
        size: "",
        price: "1,380 Baht",
        priceThai: "1,380 บาท"
      },
      {
        id: "shirt",
        title: "Exhibition commemorative T-shirt",
        titleThai: "",
        image: "/images/InOutscape/Kotaro Yokomizo/shirt.jpeg",
        medium: "Cotton (Handprinted Silkscreen)",
        mediumThai: "",
        size: "Size M",
        price: "1,050 Baht",
        priceThai: "1,050 บาท"
      },
      {
        id: "silkscreen",
        title: "Handprinted Silkscreen",
        titleThai: "",
        image: "/images/InOutscape/Kotaro Yokomizo/silkscreen.jpeg",
        medium: "Silkscreen on handmade paper",
        mediumThai: "",
        size: "",
        price: "950 Baht",
        priceThai: "950 บาท"
      },
      { id: "uramichi-1", title: "Uramichi 1", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi 1.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-2", title: "Uramichi 2", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi2.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-3", title: "Uramichi 3", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi3.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-4", title: "Uramichi 4", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi4.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-5", title: "Uramichi 5", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi5.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-6", title: "Uramichi 6", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi6.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-7", title: "Uramichi 7", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi7.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-8", title: "Uramichi 8", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi8.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-9", title: "Uramichi 9", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi9.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-10", title: "Uramichi 10", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi10.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-11", title: "Uramichi 11", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi11.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-12", title: "Uramichi 12", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi12.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" },
      { id: "uramichi-13", title: "Uramichi 13", titleThai: "", image: "/images/InOutscape/Kotaro Yokomizo/uramichi13.jpeg", medium: "", mediumThai: "", size: "", price: "To be discussed", priceThai: "โปรดสอบถามราคา" }
    ]
  },
  {
    id: "praween-piangchompoo",
    name: "Praween Piangchoompu",
    nameThai: "",
    background: {
      en: "Praween Piangchoompu works with woodcut relief prints that explore space, atmosphere, and light. His images of seemingly vacant rooms invite audiences to perceive the allure of emptiness, orchestrating objects and illumination to preserve memory beyond the physical presence of things. Education: M.F.A. (Graphic Art), Silpakorn University (2013); B.F.A., RMUTL Chiang Mai (2008).",
      th: "ประวีณ เพียงชมพู สร้างสรรค์ภาพพิมพ์แกะไม้ที่สำรวจพื้นที่ บรรยากาศ และแสง ภาพห้องว่างของเขาชวนผู้ชมสัมผัสเสน่ห์ของความว่างเปล่า จัดองค์ประกอบด้วยวัตถุและแสงเพื่อคงไว้ซึ่งความทรงจำเหนือการดำรงอยู่ทางวัตถุ การศึกษา: ศศ.ม. (ภาพพิมพ์) มหาวิทยาลัยศิลปากร (2556); ศศ.บ. มทร.ล้านนา เชียงใหม่ (2551)"
    },
    concept: {
      title: "In : Outscape",
      description: "In / Outscape brings together the subtly nuanced woodcut prints of interior spaces by Praween Piangchoompu and the sharply composed black-and-white street photography of Chiang Mai by Kotaro Yokomizo. At first glance, their practices seem worlds apart—one introspective and quiet, the other immediate and raw—but together, they form a liminal continuum between inside and out, seen and unseen, conscious and subconscious. Their works unfold like a lucid dream.",
      descriptionThai: "In / Outscape ผสมผสานภาพพิมพ์แกะไม้อันละเอียดอ่อนของพื้นที่ภายในโดยประวีณ เปียงชมพู และภาพถ่ายสตรีทขาวดำของเชียงใหม่ที่จัดวางอย่างเฉียบคมโดย Kotaro Yokomizo เมื่อแรกเห็น แนวทางของทั้งคู่ต่างกันราวคนละโลก—ด้านหนึ่งเก็บงำ เงียบสงบ อีกด้านเร่งด่วนและดิบ แต่เมื่ออยู่ร่วมกัน พวกเขากลับก่อเกิดเป็นเส้นต่อเนื่องระหว่างภายในและภายนอก สิ่งที่มองเห็นและมองไม่เห็น จิตสำนึกและจิตใต้สำนึก ผลงานคลี่ตัวราวกับความฝันอันแจ่มชัด"
    },
    artworks: [
      {
        id: "sanctuary-inside-the-soul-2020",
        title: "Sanctuary inside the soul",
        titleThai: "",
        image: "/images/InOutscape/Praween Piangchoompu/untitled folder/1copy.jpg",
        medium: "Woodcut",
        mediumThai: "",
        size: "60 x 80 cm",
        price: "35,000 Baht",
        priceThai: "35,000 บาท"
      },
      {
        id: "sanctuary-inside-the-soul-2021",
        title: "Sanctuary inside the soul",
        titleThai: "",
        image: "/images/InOutscape/Praween Piangchoompu/untitled folder/2copy.jpg",
        medium: "Woodcut",
        mediumThai: "",
        size: "60 x 85 cm",
        price: "30,000 Baht",
        priceThai: "30,000 บาท"
      },
      {
        id: "sanctuary-inside-the-soul-2022",
        title: "Sanctuary inside the soul",
        titleThai: "",
        image: "/images/InOutscape/Praween Piangchoompu/untitled folder/3copy.jpg",
        medium: "Woodcut",
        mediumThai: "",
        size: "60 x 80 cm",
        price: "35,000 Baht",
        priceThai: "35,000 บาท"
      },
      {
        id: "beyond-remembrance-2020",
        title: "Beyond Remembrance",
        titleThai: "",
        image: "/images/InOutscape/Praween Piangchoompu/untitled folder/4copy.jpg",
        medium: "Woodcut",
        mediumThai: "",
        size: "60 x 80 cm",
        price: "35,000 Baht",
        priceThai: "35,000 บาท"
      },
      {
        id: "middle-of-nowhere-n5-2021",
        title: "Middle of Nowhere N5",
        titleThai: "",
        image: "/images/InOutscape/Praween Piangchoompu/untitled folder/5copy.jpg",
        medium: "Woodcut",
        mediumThai: "",
        size: "55 x 39 cm",
        price: "30,000 Baht",
        priceThai: "30,000 บาท"
      }
    ]
  }
];


